module.exports = __webpack_public_path__ + "static/media/softwareDevelopmentImg.6fb96bff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/softwareDevelopmentImg.jpg
// module id = 859
// module chunks = 6